import React, { useState } from 'react';
import { DownOutlined, WarningFilled } from '@ant-design/icons';
import s from './s.module.less';

// 抽屉里那块「出了什么事」的固定结构（原型 issueBlockHtml），claim 与 visit 共用：
//   chip → 一句话说清发生了什么 → Causes（可折叠，装 payer 或系统给的原因）
//   → Recommendations（怎么办 + 动作按钮）→ 可选的求助行
//
// 求助行只在 visit 上出现：visit 的修复是 provider 自己的事，他可能不知道怎么做；
// 而 denied claim 是 Klarity 在跟，不该反过来让 provider 来找我们。

// Recommendations 标题前的灯泡：照抄原型 REC_SVG（品牌蓝描边），antd 的 BulbOutlined 形状与颜色都不一样
const RecIcon = () => (
    <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#0E62F4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ flex: 'none' }}
        aria-hidden="true"
    >
        <path d="M9 18h6" />
        <path d="M10 21h4" />
        <path d="M12 3a6 6 0 0 0-4 10.5c.7.6 1 1.2 1 1.5h6c0-.3.3-.9 1-1.5A6 6 0 0 0 12 3Z" />
    </svg>
);

type Props = {
    tone: 'red' | 'amber';
    chip: string;
    issue: React.ReactNode;
    causes: React.ReactNode;
    recommendation: React.ReactNode;
    actions?: React.ReactNode;
    support?: React.ReactNode;
};

const IssueBlock = ({ tone, chip, issue, causes, recommendation, actions, support }: Props) => {
    const [causesOpen, setCausesOpen] = useState(true);

    return (
        <div className={`${s.issueBlock} ${tone === 'amber' ? s.issueBlockAmber : ''}`}>
            <span className={`${s.issueChip} ${tone === 'red' ? s.issueChipRed : ''}`}>
                <WarningFilled />
                {chip}
            </span>
            <div className={s.issueHeadline}>{issue}</div>

            <div className={`${s.isec} ${causesOpen ? s.isecOpen : ''}`}>
                <button type="button" className={s.isecHead} onClick={() => setCausesOpen((v) => !v)}>
                    <DownOutlined className={s.isecCaret} />
                    Causes
                </button>
                {causesOpen && <div className={s.isecBody}>{causes}</div>}
            </div>

            <div className={s.fixBox}>
                <div className={s.fixBoxHead}>
                    <RecIcon />
                    Recommendations
                </div>
                <div className={s.issueText}>{recommendation}</div>
                {actions && <div className={s.issueBtns}>{actions}</div>}
            </div>

            {support && <div className={s.issueSupport}>{support}</div>}
        </div>
    );
};

export default IssueBlock;
